export const storageTokenKeys = {
  accessToken: 'auth-token',
  refreshToken: 'refresh-token',
  refreshTokenExpiresAt: 'refresh-token-expires-at',
  accessTokenExpiresAt: 'access-token-expires-at'
};

export const emptyFunc: Function = () => {
};
